  <script>

	import './style.scss'

	export default {
		name: 'about',
	}

</script>

<template>
	<div class='about'>
		<header>
			<h1>
				About
			</h1>
		</header>
		<div class='container'>
			TechInterviewClub is a group of hackers currently going through technical interviews. So far, it has a large bank of questions recently asked by top tech companies in the last six months. If you're a student and would like access to the questions, send us a quick email to founders@techinterview.co about your situation! We like helping out.
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/About/About.vue